export var Reasons;
(function (Reasons) {
    Reasons["Voluntary"] = "Voluntary";
    Reasons["Unvoluntary"] = "Unvoluntary";
})(Reasons || (Reasons = {}));
